<template>
  <div id="loading" class="loading touch" @mousedown.prevent=""
                                          @mouseup.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="touchScreen">
    <img class="bgImg bgImgRatio" :src="this.bgImg">
    <div class="loadingContentBox">

      
      <!-- <img class="imgLoadingIcon" :src="this.imgLoadingIcon"/> -->
      
      <div class="loadingDiv">
        <div class="spinner-box">
          <div class="circle-border">
            <div class="circle-core"></div>
          </div>
        </div>
        <img class="loadingTextTC" v-if="this.language == 'TC'" src="~@/../src/assets/images/loadingScreen/londingTextTC.png">
        <img class="loadingTextEN" v-if="this.language == 'EN'" src="~@/../src/assets/images/loadingScreen/londingTextEN.png">
      </div>

      
    </div>
    <img class="disneyLogo" :src="this.logo"/>
  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '../store'
import base64Bg from '@/assets/images/base64/bg.js';
import base64Logo from '@/assets/images/base64/logo.js';
import * as commonFunction from '@/commonFunction/commonFunction'

export default {
  name: 'loading',
  data () {
    return {
      language : i18n.locale,
      isShowPoweredBy8thWall : false,
      bgImg : base64Bg.data,
      logo : base64Logo.data,
    }
  },
  created(){
    gtag('event', 'page_view', { 
      'page_title': 'Loading Page',
      'send_to': 'G-LPYZD9LDDW'
    });

    if(commonFunction.isIOSwithChrome()){
      setTimeout(function(){
        var style = document.getElementById("loading").getAttribute("style");
        if(style != null){
          var addStyle = style + "height:" + window.innerHeight + "px;";
        }
        else{
          var addStyle = "height:" + window.innerHeight + "px;";
        }
        document.getElementById("loading").setAttribute("style",addStyle);
        store.state.isShowLoadingScreen = true;
      },200)

    }
    else{
      store.state.isShowLoadingScreen = true;
    }
    
  },
  methods:{
    touchScreen(){
      if(store.state.isLoadVideoFinish && commonFunction.isAndroidFirefox()){
        store.state.isShowLoadingScreen = false;
        store.state.isShowJourney = true;
        store.state.isShowMainMenuButton = true;
      }
    }
    // checkLoadedAssets(){
    //   if(this.isLoadedLibrary && this.isLoadedMap && this.isLoadedGPS){
    //     setTimeout(function(){
    //       store.state.isEverythingsLoaded = true;
    //       store.state.isShowLoadingScreen = false;
    //       store.state.processingStage = "idle";

    //     }, 1000);
    //   }
    // },

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },
}
</script>

<style scoped>
  .disneyLogo{
      position: absolute;
      top: 24px;
      left: 50%;
      transform: translate3d(-50%,0,0);
      width: 120px;
      height: auto;
  }
  .bgImg{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
  }

  @media (max-aspect-ratio: 3360 / 1890){.bgImgRatio{min-width: 100%;max-height: 100%}}
  @media (min-aspect-ratio: 3360 / 1890){.bgImgRatio{max-width: 100%;min-height: 100%}}

  .loading{
    position: fixed;
    top: 0px;left: 0px;
    width: 100%;
    height: calc(100% + 5px);
    background-color: #3b65a3;
    overflow: hidden;
  }

  .loadingContentBox{
    position: absolute;
    left: 50%;
    transform: translate3d(-50%,0%,0);
    top: 0%;
    width: 100%;
    max-width: 40vmax;
    height: 100%;
/*    background-color: white;*/
  }

  .loadingDiv{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }

  .loadingTextTC{
    width: 100px;
  }
  .loadingTextEN{
    width: 220px;
  }

  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to{
      transform: rotate(359deg);
    }
  }

  .spinner-box {
    width: 70px;
    height: 70px;
    position: relative;
    top: 50%;
    left: 47%;
    transform: translate3d(-50%,-50%,0);
  }

  .circle-border {
    width: 70px;
    height: 70px;
    padding: 3px;
    border-radius: 50%;
    background: linear-gradient(0deg, rgba(76,176,223,0.1) 33%, rgba(76,176,223,1) 100%);
    animation: spin .8s linear 0s infinite;
  }

  .circle-core {
    width: 70px;
    height: 70px;
    background-color: #143977;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue